import { render } from "./services_tab.vue?vue&type=template&id=e5a3e96c"
import script from "./services_tab.vue?vue&type=script&lang=js"
export * from "./services_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__